import React from 'react';
import { openContactMethod } from '../../lib/email';
import getFormatMessage from '../../locales/get-format-message';

interface IProps {
  // readonly to?: string;
  readonly text?: string;
}
export const Mailto = (_props: IProps) => {
  const text = getFormatMessage('contact_us_upper');
  // const to = props.to || MAILTO;
  const onEmail = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    openContactMethod(event);
  };
  return (
    <a href="javascript:;" onClick={onEmail}>
      {' '}
      {text}{' '}
    </a>
  );
};
